/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class PromptSortCriteria {
    getFixupPrototypeFunction() { return PromptSortCriteria.fixupPrototype; }

    static newInstance(model: Partial<PromptSortCriteria>): PromptSortCriteria {
        let obj = Object.assign(new PromptSortCriteria(), model);
        PromptSortCriteria.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<PromptSortCriteria>): PromptSortCriteria {
        if (!model) return null;
        return PromptSortCriteria.newInstance(<PromptSortCriteria> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: PromptSortCriteria) {
        if (!obj) return;

        models.PromptSortCriteria.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: PromptSortCriteria): boolean {
        Object.setPrototypeOf(obj, PromptSortCriteria.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    column: models.PromptSortColumn;

    ascending: boolean;

}
